import { render, staticRenderFns } from "./Termo.vue?vue&type=template&id=202d902e&scoped=true&"
import script from "./Termo.vue?vue&type=script&lang=js&"
export * from "./Termo.vue?vue&type=script&lang=js&"
import style0 from "./Termo.vue?vue&type=style&index=0&id=202d902e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202d902e",
  null
  
)

export default component.exports